import { format } from 'date-fns'

// default format if nothing passed
const defaultFormat = 'MM/dd/yyyy'

// Main function
export default function formatDate(date, dateFormat = defaultFormat) {
  return format(new Date(date), dateFormat)
}